// import hooks  useEffect,
import { useRef } from "react";
import { useTranslation } from "react-i18next";

// import components
import { Container, Row, Col } from "react-bootstrap";

// import assets

import "../../assets/css/cards.css";
import { globe } from "../../utils/cards-svgs";

// import data
import commonQuestions from "../../utils/data/commonQuestions";

const CommonQuestions = () => {
    const [t] = useTranslation("global");
    const itemsRef = useRef([]);

    const expandQ = (el) => {
        let oldClass = el.className;
        let newClass = "";
        // console.log(oldClass);
        if (oldClass == "commmon-q-card") {
            newClass = "commmon-q-card expand";
        } else {
            newClass = "commmon-q-card";
        }
        el.className = newClass;
        // console.log(`old class: ${oldClass} - new class: ${newClass}`);
    };

    return (
        <div className="common-q-container-div">
            <Container className="common-q-container">
                <h1 className="card-list-header clients-opnions-h">
                    {t("main.questions")}
                </h1>
                <Row className="common-q-row">
                    {commonQuestions.map((q, i) => (
                        <Col key={q.id} className="commmon-q-card-col" lg={6}>
                            <div
                                key={i}
                                ref={(el) => (itemsRef.current[i] = el)}
                                className="commmon-q-card"
                            >
                                <div
                                    className="common-q-head"
                                    onClick={() => expandQ(itemsRef.current[i])}
                                >
                                    <p>
                                        <img
                                            src={globe}
                                            alt="icon"
                                            className="common-q-globe"
                                        />
                                        <span className="q-span">{q.q}</span>
                                    </p>
                                    <div className="plus-container">
                                        <span className="plus-h"></span>
                                        <span className="plus-v"></span>
                                    </div>
                                </div>
                                <div className="common-q-ans">
                                    <p>{q.ans}</p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default CommonQuestions;
